"use strict";
/**
 * Affiliate commission terms resolution.
 *
 * NOTE: distinct from `lib/commission.ts`, which is per-sale-line STAFF
 * commission. This module is the affiliate/referral program.
 *
 * The cascade deal → affiliate → global is the SAME one the affiliate portal
 * already displays (affiliate-service/handlers/affiliates.ts). The pay path
 * previously read only the affiliate record and ignored `assignedDealId`, so an
 * affiliate on a deal was SHOWN one rate and PAID another.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCommissionTerms = resolveCommissionTerms;
exports.computeAffiliateCommission = computeAffiliateCommission;
function hasTerms(o) {
    return !!o && (o.commissionMode === 'flat' || o.commissionMode === 'percentage' || o.commissionMode === 'both');
}
const normalise = (o) => ({
    commissionMode: o.commissionMode,
    flatFee: typeof o.flatFee === 'number' ? o.flatFee : 0,
    percentageRate: typeof o.percentageRate === 'number' ? o.percentageRate : 0,
});
function resolveCommissionTerms(deal, affiliate, globalSettings) {
    if (hasTerms(deal))
        return normalise(deal);
    if (hasTerms(affiliate))
        return normalise(affiliate);
    return globalSettings;
}
/** Whole cents, rounded down, never negative. */
function computeAffiliateCommission(terms, paymentAmount) {
    const amount = Math.max(0, paymentAmount || 0);
    let commission = 0;
    if (terms.commissionMode === 'flat' || terms.commissionMode === 'both')
        commission += terms.flatFee || 0;
    if (terms.commissionMode === 'percentage' || terms.commissionMode === 'both') {
        commission += Math.floor(amount * (terms.percentageRate || 0) / 100);
    }
    return Math.max(0, commission);
}
//# sourceMappingURL=affiliateCommission.js.map